import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import login from '@/views/login'
import printDesign from '@/views/printDesign'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/printDesign',
      name: 'printDesign',
      component: printDesign,
    },
    {
      path: '/',
      name: 'index',
      component: index,
      redirect: '/login',
      children: [{
          // 概况页面==我的桌面
          path: 'mydesktop',
          name: 'mydesktop',
          component: () => import('../views/sp/Survey/Desktop/MyDesktop.vue'),
        },
        {
          // 概况页面==经营
          path: 'survey',
          name: 'survey',
          component: () => import('../views/sp/Survey/Management/survey.vue'),
        },
        // 概况页面==客均分析
        {
          path: 'customeraverageanalysis',
          name: 'customeraverageanalysis',
          component: () => import('../views/sp/Survey/Management/CustomerAverageAnalysis.vue'),
        },
        // 概况页面==交易排行
        {
          path: 'transactionranking',
          name: 'transactionranking',
          component: () => import('../views/sp/Survey/Management/TransactionRanking.vue'),
        },
        // 概况页面==滞销分析
        {
          path: 'unsalableanalysis',
          name: 'unsalableanalysis',
          component: () => import('../views/sp/Survey/Management/UnsalableAnalysis.vue'),
        },
        // 概况页面==盘损分析
        {
          path: 'inventorylossanalysis',
          name: 'inventorylossanalysis',
          component: () => import('../views/sp/Survey/Management/InventoryLossAnalysis.vue'),
        },
        // 概况页面==进销一览
        {
          path: 'purchaseandsaleslist',
          name: 'purchaseandsaleslist',
          component: () => import('../views/sp/Survey/Management/PurchaseAndSalesList.vue'),
        },
        // 概况页面==会员消费
        {
          path: 'memberconsumption',
          name: 'memberconsumption',
          component: () => import('../views/sp/Survey/Retail/MemberConsumption.vue'),
        },
        // 概况页面==会员留存
        {
          path: 'retainedmembers',
          name: 'retainedmembers',
          component: () => import('../views/sp/Survey/Retail/RetainedMembers.vue'),
        },
        // 概况页面==客户消费
        {
          path: 'customerconsumption',
          name: 'customerconsumption',
          component: () => import('../views/sp/Survey/Wholesale/CustomerConsumption.vue'),
        },
        // 概况页面==客户留存
        {
          path: 'customerretention',
          name: 'customerretention',
          component: () => import('../views/sp/Survey/Wholesale/CustomerRetention.vue'),
        },
        {
          path: 'smsSet',
          name: "smsSet",
          component: () => import('../views/sp/Member/Operation/smsSet.vue')
        },
        // 短信通知
        {
          path: 'smsSet',
          name: "smsSet",
          component: () => import('../views/sp/Member/Operation/smsSet.vue')
        },
        // 短信通知
        {
          path: 'wxCardBag',
          name: "wxCardBag",
          component: () => import('../views/sp/Member/Operation/wxCardBag.vue')
        },
        // 次卡项目
        {
          path: 'onceCard',
          name: "onceCard",
          component: () => import('../views/sp/Member/Operation/onceCard.vue')
        },
        // 页面设计
        {
          path: 'pagedesign',
          name: "pagedesign",
          component: () => import('../views/sp/MicroMall/StoreManagement/PageDesign.vue')
        },
        // 店铺设置
        {
          path: 'scDh',
          name: "scDh",
          component: () => import('../views/sp/MicroMall/scDh.vue')
        },
        // 店铺设置
        {
          path: 'setupshop',
          name: "setupshop",
          component: () => import('../views/sp/MicroMall/StoreManagement/SetUpShop.vue')
        },
        // 订单管理
        {
          path: 'ordermanagement',
          name: "ordermanagement",
          component: () => import('../views/sp/MicroMall/OrderForm/OrderManagement.vue')
        },
        // 售后订单
        {
          path: 'aftersalesorder',
          name: "aftersalesorder",
          component: () => import('../views/sp/MicroMall/OrderForm/AfterSalesOrder.vue')
        },
        //单据明细
        {
          path: 'onlineOrderDetail',
          name: "onlineOrderDetail",
          component: () => import('../views/sp/MicroMall/OrderForm/onlineOrderDetail.vue')
        },
        //商品明细
        {
          path: 'onlineProDetail',
          name: "onlineProDetail",
          component: () => import('../views/sp/MicroMall/OrderForm/onlineProDetail.vue')
        },
        //商品汇总
        {
          path: 'onlineProTotal',
          name: "onlineProTotal",
          component: () => import('../views/sp/MicroMall/OrderForm/onlineProTotal.vue')
        },
        // 线上商品
        {
          path: 'onlinegoods',
          name: "onlinegoods",
          component: () => import('../views/sp/MicroMall/Commodity/OnlineGoods.vue')
        },
        // 优惠券
        {
          path: 'coupon',
          name: 'coupon',
          component: () => import('@/views/sp/MicroMall/Marketing/coupon/Coupon.vue')
        },
        {
          path: 'fxYl',
          name: 'fxYl',
          component: () => import('@/views/sp/MicroMall/Marketing/fxYl/fxYl.vue')
        },
        // 用户领取记录
        {
          path: 'userreceivingrecord',
          name: "userreceivingrecord",
          component: () => import('../views/sp/MicroMall/Marketing/coupon/UserReceivingRecord.vue')
        },
        // 砍价优惠
        {
          path: 'bargainoffer',
          name: "bargainoffer",
          component: () => import('../views/sp/MicroMall/Marketing/bargainoffer/BargainOffer.vue')
        },
        // 用户砍价列表
        {
          path: 'userbargaininglist',
          name: "userbargaininglist",
          component: () => import('../views/sp/MicroMall/Marketing/bargainoffer/userbargaininglist.vue')
        },
        // 添加砍价
        {
          path: 'addbargain',
          name: "addbargain",
          component: () => import('../views/sp/MicroMall/Marketing/bargainoffer/AddBargain.vue')
        },
        // 秒杀管理
        {
          path: 'secondkillmanagement',
          name: "secondkillmanagement",
          component: () => import(
            '../views/sp/MicroMall/Marketing/secondkillmanagement/SecondKillManagement.vue')
        },
        // 用户秒杀列表
        // {
        //   path: 'userseckilllist',
        //   name: "userseckilllist",
        //   component: () => import('../views/sp/MicroMall/Marketing/secondkillmanagement/UserSeckillList.vue')
        // },
        // 添加秒杀
        // {
        //   path: 'addsecondkill',
        //   name: "addsecondkill",
        //   component: () => import('../views/sp/MicroMall/Marketing/secondkillmanagement/AddSecondKill.vue')
        // },
        // 团购管理
        {
          path: 'grouppurchasemanagement',
          name: "grouppurchasemanagement",
          component: () => import(
            '../views/sp/MicroMall/Marketing/GrouppurChasemanagEment/GrouppurChasemanagEment.vue')
        },
        // 用户团购列表
        // {
        //   path: 'usercollagelist',
        //   name: "usercollagelist",
        //   component: () => import('../views/sp/MicroMall/Marketing/GrouppurChasemanagEment/UserCollageList.vue')
        // },
        // 添加团购
        // {
        //   path: 'addcollage',
        //   name: "addcollage",
        //   component: () => import('../views/sp/MicroMall/Marketing/GrouppurChasemanagEment/AddCollage.vue')
        // },
        // 预售管理
        {
          path: 'presalemanagement',
          name: "presalemanagement",
          component: () => import('../views/sp/MicroMall/Marketing/Presalemanagement/PreSaleManagement.vue')
        },
        // 用户预售列表
        // {
        //   path: 'userpre-saleList',
        //   name: "userpre-saleList",
        //   component: () => import('../views/sp/MicroMall/Marketing/Presalemanagement/UserPre-SaleList.vue')
        // },
        // 添加预售
        // {
        //   path: 'addpre-sale',
        //   name: "addpre-sale",
        //   component: () => import('../views/sp/MicroMall/Marketing/Presalemanagement/AddPre-Sale.vue')
        // },
        // 接龙管理
        {
          path: 'solitairemanagement',
          name: "solitairemanagement",
          component: () => import('../views/sp/MicroMall/Marketing/Solitairemanagement/SolitaireManagement.vue')
        },
        // 用户接龙列表
        {
          path: 'usersolitairelist',
          name: "usersolitairelist",
          component: () => import('../views/sp/MicroMall/Marketing/Solitairemanagement/UserSolitaireList.vue')
        },
        // 添加接龙
        {
          path: 'addsolitaire',
          name: "addsolitaire",
          component: () => import('../views/sp/MicroMall/Marketing/Solitairemanagement/AddSolitaire.vue')
        },
        // 新人优惠
        {
          path: 'newcomerdiscount',
          name: "newcomerdiscount",
          component: () => import('../views/sp/MicroMall/Marketing/Newcomerdiscount/NewcomerDiscount.vue')
        },
        // 新用户优惠列表
        // {
        //   path: 'newuserofferlist',
        //   name: "newuserofferlist",
        //   component: () => import('../views/sp/MicroMall/Marketing/Newcomerdiscount/NewUserOfferList.vue')
        // },
        // 添加优惠
        // {
        //   path: 'addoffers',
        //   name: "addoffers",
        //   component: () => import('../views/sp/MicroMall/Marketing/Newcomerdiscount/AddOffers.vue')
        // },
        // 猜你喜欢
        {
          path: 'guessyoulikeit',
          name: "guessyoulikeit",
          component: () => import('../views/sp/MicroMall/Marketing/Guessyoulikeit/GuessYouLikeIt.vue')
        },
        // 用户收藏列表
        {
          path: 'userfavoritelist',
          name: "userfavoritelist",
          component: () => import('../views/sp/MicroMall/Marketing/Guessyoulikeit/UserFavoriteList.vue')
        },
        // 添加收藏
        {
          path: 'addcollection',
          name: "addcollection",
          component: () => import('../views/sp/MicroMall/Marketing/Guessyoulikeit/AddCollection.vue')
        },
        // 精选
        {
          path: 'selected',
          name: "selected",
          component: () => import('../views/sp/MicroMall/Marketing/Selected/Selected.vue')
        },
        // 添加精选
        {
          path: 'addselection',
          name: "addselection",
          component: () => import('../views/sp/MicroMall/Marketing/Selected/AddSelection.vue')
        },
        // 用户精选列表
        {
          path: 'userselectionlist',
          name: "userselectionlist",
          component: () => import('../views/sp/MicroMall/Marketing/Selected/UserSelectionList.vue')
        },
        // 热销
        {
          path: 'hotsale',
          name: "hotsale",
          component: () => import('../views/sp/MicroMall/Marketing/Hotsale/HotSale.vue')
        },
        // 添加热销
        {
          path: 'addhotsales',
          name: "addhotsales",
          component: () => import('../views/sp/MicroMall/Marketing/Hotsale/AddHotSales.vue')
        },
        // 用户热销列表
        {
          path: 'userhotsellinglist',
          name: "userhotsellinglist",
          component: () => import('../views/sp/MicroMall/Marketing/Hotsale/UserHotSellingList.vue')
        },
        // 新品
        {
          path: 'newproducts',
          name: "newproducts",
          component: () => import('../views/sp/MicroMall/Marketing/NewProducts/NewProducts.vue')
        },
        // 添加新品
        {
          path: 'addnewproduct',
          name: "addnewproduct",
          component: () => import('../views/sp/MicroMall/Marketing/NewProducts/AddNewProduct.vue')
        },
        // 用户新品列表
        {
          path: 'usernewproductlist',
          name: "usernewproductlist",
          component: () => import('../views/sp/MicroMall/Marketing/NewProducts/UserNewProductList.vue')
        },
        // 签到设置
        {
          path: 'signin',
          name: "signin",
          component: () => import('../views/sp/MicroMall/Marketing/SignIn/Signin.vue')
        },
        // 基础导航
        {
          path: 'jcDh',
          name: "jcDh",
          component: () => import('../views/sp/Commodity/jcDh.vue')
        },
        // 供应商档案
        {
          path: 'supplier',
          name: "supplier",
          component: () => import('../views/sp/Commodity/Supplier/SupplierFile.vue')
        },
        //商品档案
        {
          path: 'commodity',
          name: "commodity",
          component: () => import('../views/sp/Commodity/Supplier/commodityFile.vue')
        },
        //商品属性
        {
          path: 'proAttribute',
          name: "proAttribute",
          component: () => import('../views/sp/Commodity/Supplier/proAttribute.vue')
        },
        //打印方案
        {
          path: 'proPrinter',
          name: "proPrinter",
          component: () => import('../views/sp/Commodity/Supplier/proPrinter.vue')
        },
        //商品
        {
          path: 'assortedGoods',
          name: "assortedGoods",
          component: () => import('../views/sp/Commodity/AssortedGoods/assortedGoods.vue')
        },
        // 导入
        // {
        //   path: 'oneclicklmportgoods',
        //   name: 'oneclicklmportgoods',
        //   component: () => import('../views/sp/Commodity/Supplier/Lmport/OneClickLmportGoods.vue'),
        // },
        // 标签打印
        {
          path: 'labelprinting',
          name: 'labelprinting',
          component: () => import('../views/sp/Commodity/Label/LabelPrinting.vue'),
        },
        // 散装传秤
        {
          path: 'bulkweighing',
          name: 'bulkweighing',
          component: () => import('../views/sp/Commodity/Bulk/BulkWeighing.vue'),
        },
        //资金账户
        {
          path: 'capitalaccount',
          name: 'capitalaccount',
          component: () => import('../views/sp/Commodity/GeneralInformation/Capitalaccount.vue'),
        },
        // 品牌信息
        {
          path: 'brandInfo',
          name: 'brandInfo',
          component: () => import('../views/sp/Commodity/GeneralInformation/brandInfo.vue'),
        },
        //费用项目
        {
          path: 'expenseitem',
          name: 'expenseitem',
          component: () => import('../views/sp/Commodity/GeneralInformation/ExpenseItem.vue'),
        },
        //单位信息
        {
          path: 'unitinformation',
          name: 'unitinformation',
          component: () => import('../views/sp/Commodity/GeneralInformation/UnitInformation.vue'),
        },
        // 门店档案
        {
          path: 'store',
          name: 'store',
          component: () => import('../views/sp/Commodity/StoreFile/StoreFile.vue'),
        },
        // 员工档案
        {
          path: 'employees',
          name: 'employees',
          component: () => import('../views/sp/Commodity/Employee/EmployeeFiles.vue'),
        },
        // 员工权限
        {
          path: 'employeeauthority',
          name: 'employeeauthority',
          component: () => import('../views/sp/Commodity/Employee/EmployeeAuthority.vue'),
        },
        // 采购导航
        {
          path: 'cgDh',
          name: 'cgDh',
          component: () => import('../views/sp/Purchase/cgDh.vue'),
        },
        // 采购进货
        {
          path: 'purchaseandpurchase',
          name: 'purchaseandpurchase',
          component: () => import('../views/sp/Purchase/Purchase/PurchaseAndPurchase.vue'),
        },
        // 采购退货
        {
          path: 'purchasereturn',
          name: 'purchasereturn',
          component: () => import('../views/sp/Purchase/Purchase/PurchaseReturn.vue'),
        },
        // 单据明细
        {
          path: 'documentdetailscgdj',
          name: 'documentdetailscgdj',
          component: () => import('../views/sp/Purchase/ReportForm/DocumentDetailsCGDJ.vue'),
        },
        // 商品明细
        {
          path: 'commoditydetails',
          name: 'commoditydetails',
          component: () => import('../views/sp/Purchase/ReportForm/CommodityDetails.vue'),
        },
        // 商品汇总
        {
          path: 'commoditysummary',
          name: 'commoditysummary',
          component: () => import('../views/sp/Purchase/ReportForm/CommoditySummary.vue'),
        },
        // 账款汇总
        {
          path: 'accountsummary',
          name: 'accountsummary',
          component: () => import('../views/sp/Purchase/Settlement/AccountSummary.vue'),
        },
        // 账款明细
        {
          path: 'accountdetails',
          name: 'accountdetails',
          component: () => import('../views/sp/Purchase/Settlement/AccountDetails.vue'),
        },
        // 零售 = 交班对账
        {
          path: 'shifthandoverreconciliation',
          name: 'shifthandoverreconciliation',
          component: () => import('../views/sp/Retail/ReportForms/ShiftHandoverReconciliation.vue'),
        },
        // 零售 = 门店收款
        {
          path: 'storecollection',
          name: 'storecollection',
          component: () => import('../views/sp/Retail/ReportForms/StoreCollection.vue'),
        },
        //零售导航
        {
          path: 'lsDh',
          name: 'lsDh',
          component: () => import('../views/sp/Retail/lsDh.vue'),
        },
        {
          path: 'fpGg',
          name: 'fpGg',
          component: () => import('../views/sp/Retail/fpGg.vue'),
        },

        // 零售 = 经营概况
        {
          path: 'businessoverview',
          name: 'businessoverview',
          component: () => import('../views/sp/Retail/ReportForms/BusinessOverview.vue'),
        },
        // 零售 = 收款明细
        {
          path: 'documentdetailsone',
          name: 'documentdetailsone',
          component: () => import('../views/sp/Retail/ReportForms/DocumentDetailsOne.vue'),
        },
        // 零售 = 单据明细
        {
          path: 'retaildetails',
          name: 'retaildetails',
          component: () => import('../views/sp/Retail/ReportForms/RetailDetails.vue'),
        },
        // 零售 = 零售明细
        {
          path: 'documentdetailsa',
          name: 'documentdetailsa',
          component: () => import('../views/sp/Retail/ReportForms/DocumentDetailsa.vue'),
        },
        //  零售 = 商品汇总
        {
          path: 'productsummary',
          name: 'productsummary',
          component: () => import('../views/sp/Retail/ReportForms/ProductSummary.vue'),
        },
        //  零售 = 商品汇总
        {
          path: 'takeWayOrder',
          name: 'takeWayOrder',
          component: () => import('../views/sp/Retail/ReportForms/takeWayOrder.vue'),
        },
        //  零售 = 商品汇总
        {
          path: 'takeWayDetail',
          name: 'takeWayDetail',
          component: () => import('../views/sp/Retail/ReportForms/takeWayDetail.vue'),
        },
        //促销导航
        {
          path: 'promotionnavigation',
          name: 'promotionnavigation',
          component: () => import('../views/sp/Retail/SalesPromotion/PromotionNavigation.vue'),
        },
        // 促销汇总
        {
          path: 'promotionsummary',
          name: 'promotionsummary',
          component: () => import('../views/sp/Retail/SalesPromotion/PromotionSummary.vue'),
        },
        // 全场折扣
        {
          path: 'fullcourtdiscount',
          name: 'fullcourtdiscount',
          component: () => import('../views/sp/Retail/SalesPromotion/FullCourtDiscount.vue'),
        },
        // 全场折扣 == 新建
        {
          path: 'fullcourtdiscount_newlybuild',
          name: 'fullcourtdiscount_newlybuild',
          component: () => import(
            '../views/sp/Retail/SalesPromotion/NewlyBuild/FullCourtDiscount_NewlyBuild.vue'),
        },
        // 满减促销
        {
          path: 'fullfieldfullreduction',
          name: 'fullfieldfullreduction',
          component: () => import('../views/sp/Retail/SalesPromotion/FullFieldFullReduction.vue'),
        },
        // 满减促销== 新建
        {
          path: 'fullfieldfullreduction_newlybuild',
          name: 'fullfieldfullreduction_newlybuild',
          component: () => import(
            '../views/sp/Retail/SalesPromotion/NewlyBuild/FullFieldFullReduction_NewlyBuild.vue'),
        },
        // 满折促销
        {
          path: 'fulldiscountpromotion',
          name: 'fulldiscountpromotion',
          component: () => import('../views/sp/Retail/SalesPromotion/FullDiscountPromotion.vue'),
        },
        // 满折促销== 新建
        {
          path: 'fulldiscountpromotion_newlybuild',
          name: 'fulldiscountpromotion_newlybuild',
          component: () => import(
            '../views/sp/Retail/SalesPromotion/NewlyBuild/FullDiscountPromotion_NewlyBuild.vue'),
        },
        // 限时特价
        {
          path: 'limitedtimespecialprice',
          name: 'limitedtimespecialprice',
          component: () => import('../views/sp/Retail/SalesPromotion/LimitedTimeSpecialPrice.vue'),
        },
        // 限时特价 ==新建
        {
          path: 'limitedtimespecialprice_newlybuild',
          name: 'limitedtimespecialprice_newlybuild',
          component: () => import(
            '../views/sp/Retail/SalesPromotion/NewlyBuild/LimitedTimeSpecialPrice_NewlyBuild.vue'),
        },
        // 套餐促销
        {
          path: 'fixedpackage',
          name: 'fixedpackage',
          component: () => import('../views/sp/Retail/SalesPromotion/FixedPackage.vue'),
        },
        // 套餐促销 ==新建
        {
          path: 'fixedpackage_newlybuild',
          name: 'fixedpackage_newlybuild',
          component: () => import('../views/sp/Retail/SalesPromotion/NewlyBuild/FixedPackage_NewlyBuild.vue'),
        },
        // 满赠促销
        {
          path: 'freepromotion',
          name: 'freepromotion',
          component: () => import('../views/sp/Retail/SalesPromotion/FreePromotion.vue'),
        },
        // 满赠促销==新建
        {
          path: 'freepromotion_newlybuild',
          name: 'freepromotion_newlybuild',
          component: () => import('../views/sp/Retail/SalesPromotion/NewlyBuild/FreePromotion_NewlyBuild.vue'),
        },
        // 组合促销
        {
          path: 'combinedpromotion',
          name: 'combinedpromotion',
          component: () => import('../views/sp/Retail/SalesPromotion/CombinedPromotion.vue'),
        },
        // 组合促销==新建
        {
          path: 'combinedpromotion_newlybuild',
          name: 'combinedpromotion_newlybuild',
          component: () => import(
            '../views/sp/Retail/SalesPromotion/NewlyBuild/CombinedPromotion_NewlyBuild.vue'),
        },
        // 卡券促销
        {
          path: 'cardcouponpromotion',
          name: 'cardcouponpromotion',
          component: () => import('../views/sp/Retail/SalesPromotion/CardCouponPromotion.vue'),
        },
        // 卡券促销==新建
        {
          path: 'cardcouponpromotion_newlybuild',
          name: 'cardcouponpromotion_newlybuild',
          component: () => import(
            '../views/sp/Retail/SalesPromotion/NewlyBuild/CardCouponPromotion_NewlyBuild.vue'),
        },
        //会员导航
        {
          path: 'hyDh',
          name: 'hyDh',
          component: () => import('../views/sp/Member/hyDh.vue'),
        },
        //会员档案
        {
          path: 'memberpro',
          name: 'memberpro',
          component: () => import('../views/sp/Member/Operation/MemberProfile.vue'),
        },
        //充值方案
        {
          path: 'rechargeScheme',
          name: 'rechargeScheme',
          component: () => import('../views/sp/Member/Operation/rechargeScheme.vue'),
        },
        //积分兑换
        {
          path: 'pointExchange',
          name: 'pointExchange',
          component: () => import('../views/sp/Member/Operation/pointExchange.vue'),
        },
        //卡券管理
        {
          path: 'cardandcouponmanagement',
          name: 'cardandcouponmanagement',
          component: () => import('../views/sp/Member/Operation/CardAndCouponManagement.vue'),
        },
        // 商品寄存
        {
          path: 'merchandisedeposit',
          name: 'merchandisedeposit',
          component: () => import('../views/sp/Member/Operation/MerchandiseDeposit.vue'),
        },
        //会员档案
        {
          path: 'giftBagManage',
          name: 'giftBagManage',
          component: () => import('../views/sp/Member/Operation/giftBagManage.vue'),
        },
        // 会员余额
        {
          path: 'memberbalance',
          name: 'memberbalance',
          component: () => import('../views/sp/Member/ReportForm/MemberBalance.vue'),
        },
        // 会员积分
        {
          path: 'membershippoints',
          name: 'membershippoints',
          component: () => import('../views/sp/Member/ReportForm/MembershipPoints.vue'),
        },
        // 兑换明细
        {
          path: 'exchangedetails',
          name: 'exchangedetails',
          component: () => import('../views/sp/Member/ReportForm/ExchangeDetails.vue'),
        },
        // 消费排行
        {
          path: 'consumptionranking',
          name: 'consumptionranking',
          component: () => import('../views/sp/Member/ReportForm/ConsumptionRanking.vue'),
        },
        // 商品排行
        {
          path: 'productranking',
          name: 'productranking',
          component: () => import('../views/sp/Member/ReportForm/ProductRanking.vue'),
        },
        //付费会员
        {
          path: 'ffHyBill',
          name: 'ffHyBill',
          component: () => import('@/views/sp/Member/ReportForm/ffHyBill.vue')
        },
        //付费会员
        {
          path: 'fxYlBill',
          name: 'fxYlBill',
          component: () => import('@/views/sp/Member/ReportForm/fxYlBill.vue')
        },
        //付费会员
        {
          path: 'hyDjBill',
          name: 'hyDjBill',
          component: () => import('@/views/sp/Member/ReportForm/hyDjBill.vue')
        },
        // 次卡项目
        {
          path: 'subcardproject',
          name: 'subcardproject',
          component: () => import('../views/sp/Member/ReportForm/SubcardProject.vue'),
        },
        // 次卡明细
        {
          path: 'subcarddetails',
          name: 'subcarddetails',
          component: () => import('../views/sp/Member/ReportForm/SubcardDetails.vue'),
        },
        // 批发导航
        {
          path: 'pfDh',
          name: 'pfDh',
          component: () => import('../views/sp/Wholesale/pfDh.vue'),
        },
        // 客户档案
        {
          path: 'customerprofile',
          name: 'customerprofile',
          component: () => import('../views/sp/Wholesale/WholesaleSon/CustomerProfile.vue'),
        },
        // 批发销售
        {
          path: 'wholesalesales',
          name: 'wholesalesales',
          component: () => import('../views/sp/Wholesale/WholesaleSon/WholesaleSales.vue'),
        },
        // 批发退货
        {
          path: 'wholesalereturn',
          name: 'wholesalereturn',
          component: () => import('../views/sp/Wholesale/WholesaleSon/WholesaleReturn.vue'),
        },
        // 批发单据明细
        {
          path: 'wholesaledocumentdetails',
          name: 'wholesaledocumentdetails',
          component: () => import('../views/sp/Wholesale/ReportForm/WholesaleDocumentDetails.vue'),
        },
        // 批发商品明细
        {
          path: 'wholesalecommoditydetails',
          name: 'wholesalecommoditydetails',
          component: () => import('../views/sp/Wholesale/ReportForm/WholesaleCommodityDetails.vue'),
        },
        // 商品批发汇总
        {
          path: 'commoditywholesalesummary',
          name: 'commoditywholesalesummary',
          component: () => import('../views/sp/Wholesale/ReportForm/CommodityWholesaleSummary.vue'),
        },
        // 客户账款汇总
        {
          path: 'customeraccountssummary',
          name: 'customeraccountssummary',
          component: () => import('../views/sp/Wholesale/Settlement/CustomerAccountsSummary.vue'),
        },
        // 客户账款明细
        {
          path: 'customeraccountdetails',
          name: 'customeraccountdetails',
          component: () => import('../views/sp/Wholesale/Settlement/CustomerAccountDetails.vue'),
        },
        // 推广==会员导航
        {
          path: 'membernavigation',
          name: 'membernavigation',
          component: () => import('../views/sp/Extension/ExtensionMember/MemberNavigation.vue'),
        },
        // 生日营销
        {
          path: 'memberbirthdaymarketing',
          name: 'memberbirthdaymarketing',
          component: () => import('../views/sp/Extension/ExtensionMember/MemberBirthdayMarketing.vue'),
        },
        // 节日营销
        {
          path: 'memberfestivalmarketing',
          name: 'memberfestivalmarketing',
          component: () => import('../views/sp/Extension/ExtensionMember/MemberFestivalMarketing.vue'),
        },
        // 精准营销
        {
          path: 'memberprecisionmarketing',
          name: 'memberprecisionmarketing',
          component: () => import('../views/sp/Extension/ExtensionMember/MemberPrecisionMarketing.vue'),
        },
        // 定期营销
        {
          path: 'memberregularmarketing',
          name: 'memberregularmarketing',
          component: () => import('../views/sp/Extension/ExtensionMember/MemberRegularMarketing.vue'),
        },
        // 新建=生日营销
        {
          path: 'memberbirthdaymarketing_newlybuild',
          name: 'memberbirthdaymarketing_newlybuild',
          component: () => import(
            '../views/sp/Extension/ExtensionMember/NewlyBuild/MemberBirthdayMarketing_NewlyBuild.vue'),
        },
        // 新建=节日营销
        {
          path: 'memberfestivalmarketing_newlybuild',
          name: 'memberfestivalmarketing_newlybuild',
          component: () => import(
            '../views/sp/Extension/ExtensionMember/NewlyBuild/MemberFestivalMarketing_NewlyBuild.vue'),
        },
        // 新建=精准营销
        {
          path: 'memberprecisionmarketing_newlybuild',
          name: 'memberprecisionmarketing_newlybuild',
          component: () => import(
            '../views/sp/Extension/ExtensionMember/NewlyBuild/MemberPrecisionMarketing_NewlyBuild.vue'),
        },
        // 新建=定期营销
        {
          path: 'memberregularmarketing_newlybuild',
          name: 'memberregularmarketing_newlybuild',
          component: () => import(
            '../views/sp/Extension/ExtensionMember/NewlyBuild/MemberRegularMarketing_NewlyBuild.vue'),
        },
        // 推广==客户导航
        {
          path: 'customernavigation',
          name: 'customernavigation',
          component: () => import('../views/sp/Extension/ExtensionCustomer/CustomerNavigation.vue'),
        },
        // 生日营销
        {
          path: 'customerbirthdaymarketing',
          name: 'customerbirthdaymarketing',
          component: () => import('../views/sp/Extension/ExtensionCustomer/CustomerBirthdayMarketing.vue'),
        },
        // 节日营销
        {
          path: 'customerfestivalmarketing',
          name: 'customerfestivalmarketing',
          component: () => import('../views/sp/Extension/ExtensionCustomer/CustomerFestivalMarketing.vue'),
        },
        // 精准营销
        {
          path: 'customerprecisionmarketing',
          name: 'customerprecisionmarketing',
          component: () => import('../views/sp/Extension/ExtensionCustomer/CustomerPrecisionMarketing.vue'),
        },
        // 定期营销
        {
          path: 'customerregularmarketing',
          name: 'customerregularmarketing',
          component: () => import('../views/sp/Extension/ExtensionCustomer/CustomerRegularMarketing.vue'),
        },
        // 新建=生日营销
        {
          path: 'customerbirthdaymarketing_newlybuild',
          name: 'customerbirthdaymarketing_newlybuild',
          component: () => import(
            '../views/sp/Extension/ExtensionCustomer/NewlyBuild/CustomerBirthdayMarketing_NewlyBuild.vue'),
        },
        // 新建=节日营销
        {
          path: 'customerfestivalmarketing_newlybuild',
          name: 'customerfestivalmarketing_newlybuild',
          component: () => import(
            '../views/sp/Extension/ExtensionCustomer/NewlyBuild/CustomerFestivalMarketing_NewlyBuild.vue'),
        },
        // 新建=精准营销
        {
          path: 'customerprecisionmarketing_newlybuild',
          name: 'customerprecisionmarketing_newlybuild',
          component: () => import(
            '../views/sp/Extension/ExtensionCustomer/NewlyBuild/CustomerPrecisionMarketing_NewlyBuild.vue'),
        },
        // 新建=定期营销
        {
          path: 'customerregularmarketing_newlybuild',
          name: 'customerregularmarketing_newlybuild',
          component: () => import(
            '../views/sp/Extension/ExtensionCustomer/NewlyBuild/CustomerRegularMarketing_NewlyBuild.vue'),
        },
        // 推广==短信
        {
          path: 'masssmssending',
          name: 'masssmssending',
          component: () => import('../views/sp/Extension/ShortMessage/MassSmsSending.vue'),
        },
        // 推广==短信
        {
          path: 'senddetails',
          name: 'senddetails',
          component: () => import('../views/sp/Extension/ShortMessage/SendDetails.vue'),
        },
        // 仓库==门店调货
        {
          path: 'storetransfer',
          name: 'storetransfer',
          component: () => import('../views/sp/Warehouse/Allocation/StoreTransfer.vue'),
        },
        // 仓库==门店账款
        {
          path: 'storeaccounts',
          name: 'storeaccounts',
          component: () => import('../views/sp/Warehouse/Allocation/StoreAccounts.vue'),
        },
        // 仓库==账款明细
        {
          path: 'accountdetailsone',
          name: 'accountdetailsone',
          component: () => import('../views/sp/Warehouse/Allocation/AccountDetailsOne.vue'),
        },
        // 仓库==商品报损
        {
          path: 'commoditylossreporting',
          name: 'commoditylossreporting',
          component: () => import('../views/sp/Warehouse/Stocktaking/CommodityLossReporting.vue'),
        },
        // 仓库==调货明细
        {
          path: 'transferDocument',
          name: 'transferDocument',
          component: () => import('../views/sp/Warehouse/Allocation/transferDocument.vue'),
        },
        // 仓库==调货明细
        {
          path: 'transferDocumentDetail',
          name: 'transferDocumentDetail',
          component: () => import('../views/sp/Warehouse/Allocation/transferDocumentDetail.vue'),
        },
        // 仓库==库存盘点
        {
          path: 'lnventorycount',
          name: 'lnventorycount',
          component: () => import('../views/sp/Warehouse/Stocktaking/LnventoryCount.vue'),
        },
        // 仓库导航
        {
          path: 'ckDh',
          name: 'ckDh',
          component: () => import('../views/sp/Warehouse/ckDh.vue'),
        },
        // 仓库==实时库存
        {
          path: 'realtimeinventory',
          name: 'realtimeinventory',
          component: () => import('../views/sp/Warehouse/WarehouseReportForm/RealTimeInventory.vue'),
        },
        // 仓库==库存明细
        {
          path: 'lnventorydetails',
          name: 'lnventorydetails',
          component: () => import('../views/sp/Warehouse/WarehouseReportForm/LnventoryDetails.vue'),
        },
        // 仓库==商品汇总
        {
          path: 'wproductsummarycksp',
          name: 'wproductsummarycksp',
          component: () => import('../views/sp/Warehouse/WarehouseReportForm/WProductSummaryCKSP.vue'),
        },
        // 仓库==盘点汇总
        {
          path: 'lnventorysummary',
          name: 'lnventorysummary',
          component: () => import('../views/sp/Warehouse/WarehouseReportForm/LnventorySummary.vue'),
        },
        // 仓库==报损单据
        {
          path: 'lossdocument',
          name: 'lossdocument',
          component: () => import('../views/sp/Warehouse/WarehouseReportForm/LossDocument.vue'),
        },
        // 仓库==调货设置
        {
          path: 'transfersettings',
          name: 'transfersettings',
          component: () => import('../views/sp/Warehouse/Chain/TransferSettings.vue'),
        },
        // 仓库==门店商品
        {
          path: 'storemerchandise',
          name: 'storemerchandise',
          component: () => import('../views/sp/Warehouse/Chain/StoreMerchandise.vue'),
        },
        // 财务==月结报表
        {
          path: 'cwDh',
          name: 'cwDh',
          component: () => import('../views/sp/Finance/cwDh.vue'),
        },
        // 财务==月结报表
        {
          path: 'monthlystatement',
          name: 'monthlystatement',
          component: () => import('../views/sp/Finance/MonthlyStatement.vue'),
        },
        // 财务==月结汇总
        {
          path: 'yjHz',
          name: 'yjHz',
          component: () => import('../views/sp/Finance/yjHz.vue'),
        },
        // 财务==资金汇总
        {
          path: 'financefundsummary',
          name: 'financefundsummary',
          component: () => import('../views/sp/Finance/FinanceFundSummary.vue'),
        },
        // 财务==资金明细
        {
          path: 'financefunddetails',
          name: 'financefunddetails',
          component: () => import('../views/sp/Finance/FinanceFundDetails.vue'),
        },
        // 财务==员工提成
        {
          path: 'financeemployeecommission',
          name: 'financeemployeecommission',
          component: () => import('../views/sp/Finance/FinanceEmployeeCommission.vue'),
        },
        // 财务==提成明细
        {
          path: 'financeroyaltydetails',
          name: 'financeroyaltydetails',
          component: () => import('../views/sp/Finance/FinanceRoyaltyDetails.vue'),
        },
        // 财务==提成商品
        {
          path: 'financecommissioncommodity',
          name: 'financecommissioncommodity',
          component: () => import('../views/sp/Finance/FinanceCommissionCommodity.vue'),
        },
        // 财务==进销概览
        {
          path: 'financepurchasesalesoverview',
          name: 'financepurchasesalesoverview',
          component: () => import('../views/sp/Finance/FinancePurchaseSalesOverview.vue'),
        },
        // 财务==销售分账
        {
          path: 'xsfz',
          name: 'xsfz',
          component: () => import('../views/sp/Finance/xsfz.vue'),
        },
        // 财务==分账查询
        {
          path: 'fzCx',
          name: 'fzCx',
          component: () => import('../views/sp/Finance/fzCx.vue'),
        },
        // 系统=系统参数
        {
          path: 'systemparameter',
          name: 'systemparameter',
          component: () => import('../views/sp/System/SystemParameter.vue'),
        },
        // 系统=数据管理
        {
          path: 'datamanagement',
          name: 'datamanagement',
          component: () => import('../views/sp/System/DataManagement.vue'),
        },
        // 系统=操作日志
        {
          path: 'operationlog',
          name: 'operationlog',
          component: () => import('../views/sp/System/OperationLog.vue'),
        },
        // 系统=登录列表
        {
          path: 'loginlist',
          name: 'loginlist',
          component: () => import('../views/sp/System/LoginList.vue'),
        },
        // 系统=关于我们
        {
          path: 'aboutus',
          name: 'aboutus',
          component: () => import('../views/sp/System/AboutUs.vue'),
        },
        //微信设置
        {
          path: 'wxSet',
          name: 'wxSet',
          component: () => import('../views/sp/Member/Operation/wxSet.vue'),
        },
        //调价单
        {
          path: 'editPriceBill',
          name: 'editPriceBill',
          component: () => import('../views/sp/Commodity/editPrice/editPriceBill.vue'),
        },
        //调价记录
        {
          path: 'editPriceRecord',
          name: 'editPriceRecord',
          component: () => import('../views/sp/Commodity/editPrice/editPriceRecord.vue'),
        },
        // 序列号
        {
          path: 'serialnumber',
          name: 'serialnumber',
          component: () => import('../views/sp/Commodity/editPrice/SerialNumber.vue'),
        },
        // 保质期
        {
          path: 'qualityguaranteeperiod',
          name: 'qualityguaranteeperiod',
          component: () => import('../views/sp/Commodity/editPrice/QualityGuaranteePeriod.vue'),
        },
        // 保质期
        {
          path: 'employeeHandover',
          name: 'employeeHandover',
          component: () => import('../views/sp/Retail/ReportForms/employeeHandover.vue'),
        },
        {
          path: 'eCard',
          name: 'eCard',
          component: () => import('../views/sp/Member/Operation/eCard.vue'),
        },
        {
          path: 'oneProMoreKh',
          name: 'oneProMoreKh',
          component: () => import('../views/sp/Wholesale/WholesaleSon/oneProMoreKh.vue'),
        },
        {
          path: 'oneProMoreGys',
          name: 'oneProMoreGys',
          component: () => import('../views/sp/Purchase/Purchase/oneProMoreGys.vue'),
        },
        //餐饮
        {
          path: 'tableAdmin',
          name: 'tableAdmin',
          component: () => import('../views/sp/cy/tableAdmin.vue'),
        },
        //加盟
        {
          path: 'zddd',
          name: 'zddd',
          component: () => import('../views/sp/jm/jmDh/zddd.vue'),
        },
        {
          path: 'jmzd',
          name: 'jmzd',
          component: () => import('../views/sp/jm/jmDh/jmzd.vue'),
        },
        {
          path: 'jmdh',
          name: 'jmdh',
          component: () => import('../views/sp/jm/jmDh/jmdh.vue'),
        },
        {
          path: 'yhdd',
          name: 'yhdd',
          component: () => import('../views/sp/jm/jmDh/yhdd.vue'),
        },
        {
          path: 'dhdd',
          name: 'dhdd',
          component: () => import('../views/sp/jm/jmDh/dhdd.vue'),
        },
        {
          path: 'jmzk',
          name: 'jmzk',
          component: () => import('../views/sp/jm/jmDh/jmzk.vue'),
        },

        {
          path: 'zbmd',
          name: 'zbmd',
          component: () => import('../views/sp/jm/zbmd.vue'),
        },
        {
          path: 'jmmd',
          name: 'jmmd',
          component: () => import('../views/sp/jm/jmmd.vue'),
        },
        {
          path: 'jmsp',
          name: 'jmsp',
          component: () => import('../views/sp/jm/jmsp.vue'),
        },
        {
          path: 'zbmd_zbSpGl',
          name: 'zbmd_zbSpGl',
          component: () => import('../views/sp/jm/zbmd_zbSpGl.vue'),
        },
        {
          path: 'jmwdMdxs',
          name: 'jmwdMdxs',
          component: () => import('../views/sp/jm/jmwdMdxs.vue'),
        },

        {
          path: 'jmwdMdph',
          name: 'jmwdMdph',
          component: () => import('../views/sp/jm/jmwdMdph.vue'),
        },
        {
          path: 'jmwdXshz',
          name: 'jmwdXshz',
          component: () => import('../views/sp/jm/jmwdXshz.vue'),
        },
        {
          path: 'jmwdShhz',
          name: 'jmwdShhz',
          component: () => import('../views/sp/jm/jmwdShhz.vue'),
        },
        {
          path: 'wdjmMdph',
          name: 'wdjmMdph',
          component: () => import('../views/sp/jm/wdjmMdph.vue'),
        },
        {
          path: 'wdjmXshz',
          name: 'wdjmXshz',
          component: () => import('../views/sp/jm/wdjmXshz.vue'),
        },
        {
          path: 'smShop',
          name: 'smShop',
          component: () => import('../views/sp/smShop/smShop.vue'),
        },
        {
          path: 'elabelAdmin',
          name: 'elabelAdmin',
          component: () => import('../views/sp/elabel/elabelAdmin.vue'),
        },
        {
          path: 'elabelProAdmin',
          name: 'elabelProAdmin',
          component: () => import('../views/sp/elabel/elabelProAdmin.vue'),
        },

      ]
    },
    {
      path: '/order-statistics',
      name: 'OrderStatistics',
      component: () => import('@/components/OrderStatistics.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js